// @ts-nocheck
/**
 * ドラフトシステム - 結果画面
 */

import React from 'react';
import { draftStyles } from './styles/draftStyles';

/**
 * ドラフト結果画面
 * @param {Object} props
 * @param {Object} props.result - ドラフト結果
 * @param {Function} props.onNewDraft - 新規ドラフトコールバック
 * @param {Function} props.onBack - 戻るコールバック
 */
export const DraftResult = ({
  result,
  onNewDraft,
  onBack,
}) => {
  const {
    placement = 1,
    wins = 0,
    losses = 0,
    cardsWon = [],
    totalPicks = 0,
  } = result || {};

  // 順位に応じたメッセージ
  const getPlacementMessage = (rank) => {
    switch (rank) {
      case 1: return '優勝！';
      case 2: return '準優勝';
      case 3: return '3位';
      case 4: return '4位';
      default: return `${rank}位`;
    }
  };

  // 順位に応じた色
  const getPlacementColor = (rank) => {
    switch (rank) {
      case 1: return '#ffd700';
      case 2: return '#c0c0c0';
      case 3: return '#cd7f32';
      default: return '#888';
    }
  };

  return (
    <div style={draftStyles.resultContainer}>
      <h1 style={draftStyles.resultTitle}>ドラフト終了</h1>

      {/* 順位 */}
      <div style={{
        ...draftStyles.resultRank,
        color: getPlacementColor(placement),
        WebkitTextFillColor: getPlacementColor(placement),
      }}>
        {getPlacementMessage(placement)}
      </div>

      {/* 統計 */}
      <div style={draftStyles.resultStats}>
        <div style={draftStyles.resultStatItem}>
          <span style={{ color: '#aaa' }}>戦績</span>
          <span style={{ color: '#fff', fontWeight: 'bold' }}>
            {wins}勝 {losses}敗
          </span>
        </div>
        <div style={draftStyles.resultStatItem}>
          <span style={{ color: '#aaa' }}>総ピック数</span>
          <span style={{ color: '#fff', fontWeight: 'bold' }}>{totalPicks}枚</span>
        </div>
        {cardsWon.length > 0 && (
          <div style={draftStyles.resultStatItem}>
            <span style={{ color: '#aaa' }}>獲得カード</span>
            <span style={{ color: '#ffd700', fontWeight: 'bold' }}>{cardsWon.length}枚</span>
          </div>
        )}
      </div>

      {/* 獲得カード */}
      {cardsWon.length > 0 && (
        <div style={{
          background: 'rgba(255, 255, 255, 0.05)',
          borderRadius: '12px',
          padding: '20px',
          marginBottom: '30px',
          maxWidth: '600px',
          width: '100%',
        }}>
          <h3 style={{ color: '#ffd700', marginBottom: '15px' }}>獲得カード</h3>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '8px',
          }}>
            {cardsWon.map((card, index) => (
              <span
                key={index}
                style={{
                  padding: '6px 12px',
                  background: 'rgba(255, 215, 0, 0.2)',
                  borderRadius: '4px',
                  fontSize: '0.9rem',
                  color: '#ffd700',
                }}
              >
                {card.name}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* アクションボタン */}
      <div style={{ display: 'flex', gap: '15px' }}>
        <button
          onClick={onNewDraft}
          style={draftStyles.startButton}
        >
          新しいドラフト
        </button>
        <button
          onClick={onBack}
          style={draftStyles.backButton}
        >
          メニューに戻る
        </button>
      </div>
    </div>
  );
};

export default DraftResult;
